import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ObjectManagerComponentBase } from '../../../core/component/object-manager/object-manager.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { LocalDate } from '../../../core/model/local-date';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { directDebitCommand } from '../../command/direct-debit';
import { DirectDebit } from '../../model/direct-debit';
import { DirectDebitCommandHandlerResolver } from '../../service/command/direct-debit-command-handler-resolver.service';
import { DirectDebitService } from '../../service/data/direct-debit.service';

@Component({
    selector: 'app-direct-debit',
    templateUrl: './direct-debit.component.html',
    styleUrls: ['./direct-debit.component.scss'],
    providers: [DirectDebitCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DirectDebitComponent extends ObjectManagerComponentBase<DirectDebit> {
  constructor(
    private _dataService: DirectDebitService,
    cdf: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    private _companyService: CompanyService,
    fb: FormBuilder,
    fcf: FormControlExFactory,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: DirectDebitCommandHandlerResolver
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);

    this.from = LocalDate.fromDate(LocalDate.today().firstDayInMonth());
    this.to = LocalDate.fromDate(this.from.lastDayInMonth());
    this.form = fb.group({
      from: fb.group({}),
      to: fb.group({}),
      company: fcf.create('COMPANY.LIST_HEADER', ''),
      payerName: fcf.create('INVOICE.RECIPIENT_NAME', ''),
    });

    this.columnDefinitions = [
      cdf.createDate('DIRECT_DEBIT.CREATED_DATE', 'createdDate'),
      cdf.createDate('DIRECT_DEBIT.DEDUCTION_DATE', 'deductionDate'),
      cdf.createDate('DIRECT_DEBIT.EXPORT_DATE', 'exportDate'),
      cdf.createDate('DIRECT_DEBIT.TRANSACTION_DATE', 'transactionDate'),
      cdf.create('DIRECT_DEBIT.PAYER_NAME', 'payerNumber'),
      cdf.create('INVOICE.RECIPIENT_NAME', 'debtorName'),
      cdf.create('DIRECT_DEBIT.PAYMENT_STATUS', 'paymentStatusCodeText'),
      cdf.create('DIRECT_DEBIT.INVOICE_NUMBER', 'invoiceNumber'),
      cdf.createDate('INVOICE.DUE_DATE', 'invoiceDueDate'),
      cdf.createMoney('DIRECT_DEBIT.AMOUNT', 'amount'),
      cdf.createMoney('DIRECT_DEBIT.REMAINING_AMOUNT', 'unPaidAmount'),
    ];

    this.addContextMenuItemDefinition('COMMON.OPEN_INVOICE', directDebitCommand.openInvoice);
    this.preferencesKey = 'invoice.direct-debit.list';
  }

  from: LocalDate;
  to: LocalDate;

  columnDefinitions: ColumnDefinition[];
  dataContext: DirectDebit[];
  form: FormGroup;
  companies: { name: string; value: string }[];

  ngOnInit() {
    this._companyService.getList().subscribe(data => {
      this.companies = [{ name: 'ALL_TEXT', value: '' }];
      data.forEach(item => {
        this.companies.push({ name: item.toString(), value: item.id });
      });
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    this._dataService.getDirectDebit(this.form.value).subscribe(items => {
      this.dataContext = items;
    });
  }
}
